'use client';
import {Dispatch, SetStateAction} from 'react';
import {useRouter} from 'next/navigation';

import Modal from '../Modal';
import IBookVillageDictionary from '@/dictionaries/pages/bookVillage/types';
import Button from '../Button';

import {getStorageBooking, deleteStorageBooking} from '@/utils/helpers';

type Props = {
  modalIsOpen: boolean;
  onOpenChange: Dispatch<SetStateAction<boolean>>;
  dict: IBookVillageDictionary;
  setVillageSlug(slug: string): void;
  lang: string;
};

export default function BookingReminder({
  modalIsOpen,
  onOpenChange,
  dict,
  setVillageSlug,
  lang,
}: Props) {
  const {push} = useRouter();

  const {title, youLeftTheBooking, areYouSure, cancelBooking, completeBooking} =
    dict.modal.reminder;

  function handleContinueBooking() {
    const booking = getStorageBooking();

    if (booking.bookingId && booking.slug) {
      if (lang === 'en') {
        push(`/book-villa?booking_id=${booking.bookingId}`);
        setVillageSlug(booking.slug);
      } else {
        push(`/${lang}/book-villa?booking_id=${booking.bookingId}`);
        setVillageSlug(booking.slug);
      }
      onOpenChange(false);
    }
  }

  function handleCancelBooking() {
    deleteStorageBooking();
    onOpenChange(false);
  }

  return (
    <Modal.Root open={modalIsOpen} onOpenChange={onOpenChange}>
      <Modal.Content
        hideXButton
        preventOutsideClick
        contentCustomClass="md:!top-[calc(50%-15vh)] md:!w-[600px] desktop:!min-w-[800px]"
        onOpenChange={onOpenChange}>
        <div className="w-full h-full flex flex-col">
          <h3 className="font-semibold mb-2 text-center text-4xl leading-[1.25]">
            {title}
          </h3>
          <p className="mb-12 text-center mt-8">
            {youLeftTheBooking}
            <br />
            {areYouSure}
          </p>
          <div className="flex flex-col md:flex-row gap-2 md:gap-8 md:justify-center">
            <Button
              onClick={handleCancelBooking}
              variant="outline"
              className="md:w-1/2">
              {cancelBooking}
            </Button>
            <Button onClick={handleContinueBooking} className="md:w-1/2">
              {completeBooking}
            </Button>
          </div>
        </div>
      </Modal.Content>
    </Modal.Root>
  );
}
